<cx-spinner class="overlay" *ngIf="isUpdating"></cx-spinner>

<form *ngIf="!claimsSuccess" class="custom-claims-form d-flex flex-column" (ngSubmit)="onSubmit()" [formGroup]="form">
  <span class="claims-header" claims-header>
    {{ "claims.header" | cxTranslate }}
  </span>
  <label class="mt-4 form-label">
    {{ "claims.invoiceNumber.label" | cxTranslate }}
    <input required="true" type="text" class="form-control mt-2" formControlName="invoiceNumber"
      placeholder="{{ 'claims.invoiceNumber.placeholder' | cxTranslate }}" />
    <cx-form-errors [control]="form.get('invoiceNumber')"></cx-form-errors>
  </label>

  <label class="mt-4 form-label">
    {{ "claims.name.label" | cxTranslate }}
    <input required="true" readonly type="text" class="form-control mt-2"
      placeholder="{{ 'claims.name.placeholder' | cxTranslate }}" formControlName="name"
      [attr.aria-label]="'claims.name.placeholder' | cxTranslate" />
    <cx-form-errors [control]="form.get('name')"></cx-form-errors>
  </label>
  <label class="mt-4 form-label">
    {{ "claims.emailAddress.label" | cxTranslate }}
    <input required="true" readonly type="email" class="form-control mt-2" formControlName="email"
      placeholder="{{ 'claims.emailAddress.placeholder' | cxTranslate }}" />
    <cx-form-errors [control]="form.get('email')"></cx-form-errors>
  </label>

  <label class="mt-4 form-label">
    {{ "claims.categoryType" | cxTranslate }}
    <select required="true" class="form-select form-control mt-2" aria-label="Default select example"
      (change)="selectCause(form.get('categoryType'))" formControlName="categoryType">
      <option value="" selected> {{ "claims.categoryHeader" | cxTranslate }}</option>
      <option *ngFor="let option of categoryTypes" [value]="option.code">
        {{option.label}}
      </option>
    </select>
    <cx-form-errors [control]="form.get('categoryType')"></cx-form-errors>
  </label>
  <label class="mt-4 form-label">
    {{ "claims.categorySubType" | cxTranslate }}
    <select required="true" class="form-select form-control mt-2" aria-label="Default select example"
      formControlName="categorySubType">
      <option value="" selected> {{ "claims.categorySubHeader" | cxTranslate }}</option>
      <option *ngFor="let cause of selectedCause" [value]="cause.code">
        {{cause.label}}
      </option>
    </select>
    <cx-form-errors [control]="form.get('categorySubType')"></cx-form-errors>
  </label>
  <label class="mt-4 form-label">
    {{ "claims.claimedValue" | cxTranslate }}
    <input required="true" type="number" class="form-control mt-2" formControlName="claimedValue"
      placeholder="{{ 'claims.claimValuePlaceHolder' | cxTranslate }}" />
    <cx-form-errors [control]="form.get('claimedValue')"></cx-form-errors>
  </label>
  <label class="mt-4 form-label">
    {{ "claims.subject.label" | cxTranslate }}
    <input required="true" type="text" class="form-control mt-2" formControlName="subject"
      placeholder="{{ 'claims.subject.placeholder' | cxTranslate }}" />
    <cx-form-errors [control]="form.get('subject')"></cx-form-errors>
  </label>
  <label class="mt-4 form-label">
    {{ "claims.description" | cxTranslate }}
    <textarea required="true" formControlName="description" class="form-control  mt-2"
      placeholder="{{ 'claims.descriptionPlaceHolder' | cxTranslate }}" rows="3"></textarea>
    <cx-form-errors [control]="form.get('description')"></cx-form-errors>
  </label>

    <label class="mt-4 form-label" *ngIf="sitecountry[1] !== 'lipton-pk'"
      ><input
        type="checkbox"
        required="true"
        formControlName="termsAndConditions"
        class="form-control mt-2 check-style"
        ng-reflect-name="termsAndConditions"
      /><span class="form-check-label">
        {{ "claims.iagree" | cxTranslate }}
        <a
          target="_blank"
          rel="noopener"
          class="cx-tc-link termsLink"
          href={{privacyPath}}
        >
        {{ "claims.privacypolicy" | cxTranslate }}
      </a></span>
  </label>
  <div class="mt-4 form-label">
    <div class="pull-right">
      <button type="submit" class="btn claims-btn btn-primary btn-success float-right btn-sm login-btn pull-right"
        [disabled]="!form.valid">
        {{ "claims.submit" | cxTranslate }}
      </button>
    </div>
    <div class="pull-right">
      <button class="btn back btn-primary btn-success float-right btn-sm login-btn pull-right" (click)="goBackHome()">
        {{ "claims.back" | cxTranslate }}
      </button>
    </div>
    <div class="clear"></div>

  </div>
</form>

<div class="custom-claims-form custom-claims-form-success d-flex flex-column" *ngIf="claimsSuccess">
  <span class="claims-success-header" claims-header>
    {{ "claims.successHeader" | cxTranslate }}
  </span>
  <div class="mt-4 claims-success-body">
    {{ "claims.successBodyOne" | cxTranslate }}
  </div>
  <div class="mt-4 claims-success-body-ticket">
    {{ "claims.successBodyThree" | cxTranslate }} {{id}}
  </div>
  <div class="mt-2 claims-success-body">
    {{ "claims.successBodyTwo" | cxTranslate }}
  </div>
  <div class="mt-2 shiftRight">
    <div class="pull-right">
      <a class="cx-tc-link goBack" (click)="goBack()">
        {{ "claims.goBack" | cxTranslate }}
      </a>
    </div>
    <div class="clear"></div>

  </div>
</div>